import { z } from 'zod'

import { FoodStockFood } from './FoodStockFood'

export const FoodStock = z.object({
  id: z.string(),
  place: z.string(),
  stockFoods: FoodStockFood.array().nullable()
})
export type FoodStock = z.infer<typeof FoodStock>

export const FoodStockList = FoodStock.array()
export type FoodStockList = z.infer<typeof FoodStockList>

export const CreateFoodStockDTO = z.object({
  patientId: z.string(),
  place: z.string()
})
export type CreateFoodStockDTO = z.infer<typeof CreateFoodStockDTO>

export const UpdateFoodStockMinimumQuantityDTO = z.object({
  minimumQuantity: z.number()
})
export type UpdateFoodStockMinimumQuantityDTO = z.infer<
  typeof UpdateFoodStockMinimumQuantityDTO
>
